import { Route, Routes } from 'react-router-dom'
import { AppShell } from './components/layout/AppShell'
import { ProtectedRoute } from './components/layout/ProtectedRoute'
import { PublicLayout } from './components/layout/PublicLayout'
import { LoginPage, SignupPage, ForgotPasswordPage } from './pages/auth/AuthPage'
import { OnboardingPage } from './pages/auth/OnboardingPage'
import { AdminDashboardPage, AdminSectionPage } from './pages/admin/AdminPages'
import { BriefsPage } from './pages/app/BriefsPage'
import { CandidatesPage, DocumentsPage, HelpPage, SettingsPage, SubscriptionPage } from './pages/app/CommonPages'
import { CompanyDiscoveryPage } from './pages/app/CompanyDiscoveryPage'
import { ComparisonPage } from './pages/app/ComparisonPage'
import { ContractsPage } from './pages/app/ContractsPage'
import { DashboardPage } from './pages/app/DashboardPage'
import { MatchingPage } from './pages/app/MatchingPage'
import { MessagesPage } from './pages/app/MessagesPage'
import { NotificationsPage } from './pages/app/NotificationsPage'
import { OpportunitiesPage } from './pages/app/OpportunitiesPage'
import { PacksPage } from './pages/app/PacksPage'
import { PartnershipsPage } from './pages/app/PartnershipsPage'
import { PaymentsPage } from './pages/app/PaymentsPage'
import { ProfilePage } from './pages/app/ProfilePage'
import { ProposalsPage } from './pages/app/ProposalsPage'
import { ReportingPage } from './pages/app/ReportingPage'
import { SelectionPage } from './pages/app/SelectionPage'
import { StatisticsPage } from './pages/app/StatisticsPage'
import { TeamPage } from './pages/app/TeamPage'
import { AthleteProfilePage } from './pages/public/AthleteProfilePage'
import { HomePage } from './pages/public/HomePage'
import { CompanyMarketplacePage } from './pages/public/CompanyMarketplacePage'
import { CompanyProfilePage } from './pages/public/CompanyProfilePage'
import { HowItWorksPage } from './pages/public/HowItWorksPage'
import { InfoPage } from './pages/public/InfoPage'
import { MarketplacePage } from './pages/public/MarketplacePage'
import { PricingPage } from './pages/public/PricingPage'
import { OpportunitiesPublicPage } from './pages/public/OpportunitiesPublicPage'

export default function App() {
  return <Routes>
    <Route element={<PublicLayout />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/athletes" element={<MarketplacePage />} />
      <Route path="/athletes/:slug" element={<AthleteProfilePage />} />
      <Route path="/opportunites" element={<OpportunitiesPublicPage />} />
      <Route path="/entreprises" element={<CompanyMarketplacePage />} />
      <Route path="/entreprises/:slug" element={<CompanyProfilePage />} />
      <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
      <Route path="/pour-les-athletes" element={<InfoPage page="pour-les-athletes" />} />
      <Route path="/pour-les-entreprises" element={<InfoPage page="pour-les-entreprises" />} />
      <Route path="/tarifs" element={<PricingPage />} />
      <Route path="/a-propos" element={<InfoPage page="a-propos" />} />
      <Route path="/faq" element={<InfoPage page="faq" />} />
      <Route path="/contact" element={<InfoPage page="contact" />} />
      <Route path="/mentions-legales" element={<InfoPage page="mentions-legales" />} />
      <Route path="/confidentialite" element={<InfoPage page="confidentialite" />} />
      <Route path="/cgu" element={<InfoPage page="cgu" />} />
      <Route path="/cookies" element={<InfoPage page="cookies" />} />
    </Route>

    <Route path="/connexion" element={<LoginPage />} />
    <Route path="/inscription" element={<SignupPage />} />
    <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
    <Route path="/onboarding/:role" element={<OnboardingPage />} />

    <Route element={<ProtectedRoute roles={['athlete', 'company']} />}>
      <Route element={<AppShell />}>
        <Route path="/app" element={<DashboardPage />} />
        <Route path="/app/messages" element={<MessagesPage />} />
        <Route path="/app/notifications" element={<NotificationsPage />} />
        <Route path="/app/documents" element={<DocumentsPage />} />
        <Route path="/app/abonnement" element={<SubscriptionPage />} />
        <Route path="/app/parametres" element={<SettingsPage />} />
        <Route path="/app/aide" element={<HelpPage />} />

        <Route path="/app/athlete/profil" element={<ProfilePage />} />
        <Route path="/app/athlete/packs" element={<PacksPage />} />
        <Route path="/app/athlete/opportunites" element={<OpportunitiesPage />} />
        <Route path="/app/athlete/matching" element={<MatchingPage />} />
        <Route path="/app/athlete/propositions" element={<ProposalsPage />} />
        <Route path="/app/athlete/contrats" element={<ContractsPage />} />
        <Route path="/app/athlete/partenariats" element={<PartnershipsPage />} />
        <Route path="/app/athlete/livrables" element={<PartnershipsPage deliverablesOnly />} />
        <Route path="/app/athlete/paiements" element={<PaymentsPage />} />
        <Route path="/app/athlete/statistiques" element={<StatisticsPage />} />

        <Route path="/app/entreprise/profil" element={<ProfilePage />} />
        <Route path="/app/entreprise/decouvrir" element={<CompanyDiscoveryPage />} />
        <Route path="/app/entreprise/matching" element={<MatchingPage />} />
        <Route path="/app/entreprise/selection" element={<SelectionPage />} />
        <Route path="/app/entreprise/comparateur" element={<ComparisonPage />} />
        <Route path="/app/entreprise/briefs" element={<BriefsPage />} />
        <Route path="/app/entreprise/candidatures" element={<CandidatesPage />} />
        <Route path="/app/entreprise/propositions" element={<ProposalsPage />} />
        <Route path="/app/entreprise/contrats" element={<ContractsPage />} />
        <Route path="/app/entreprise/partenariats" element={<PartnershipsPage />} />
        <Route path="/app/entreprise/paiements" element={<PaymentsPage />} />
        <Route path="/app/entreprise/reporting" element={<ReportingPage />} />
        <Route path="/app/entreprise/equipe" element={<TeamPage />} />
      </Route>
    </Route>

    <Route element={<ProtectedRoute roles={['admin']} />}>
      <Route element={<AppShell admin />}>
        <Route path="/admin" element={<AdminDashboardPage />} />
        {['utilisateurs', 'verifications', 'athletes', 'entreprises', 'partenariats', 'contrats', 'paiements', 'abonnements', 'litiges', 'signalements', 'matching', 'contenus', 'analytics', 'parametres'].map((section) => <Route path={`/admin/${section}`} element={<AdminSectionPage section={section} />} key={section} />)}
      </Route>
    </Route>

    <Route path="*" element={<NotFoundPage />} />
  </Routes>
}

function NotFoundPage() {
  return <main className="not-found"><img src="/brand/athlink-monogram.png" alt="AthLink" /><span className="eyebrow">Erreur 404</span><h1>Cette page n’existe pas</h1><p>Le lien a peut-être changé ou vous n’avez pas l’autorisation nécessaire.</p><a className="btn btn--primary" href="/">Retour à l’accueil</a></main>
}
